// extracted by mini-css-extract-plugin
export var bottomRightDock = "_3u-0";